import { createRoute, redirect } from "@tanstack/solid-router";
import { appRoute } from "./route";

export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  beforeLoad: () => {
    throw redirect({
      to: "/chronos",
      replace: true,
      search: (prev: Record<string, unknown>) => ({
        ...prev,
        ws: typeof prev.ws === "string" ? prev.ws : undefined,
      }),
    }) as unknown;
  },
});
